export default "__VITE_ASSET__BTAx686x__"